import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, useLocation } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";

import { AuthProvider } from "./context/authContext";
import Layout from "./components/layout/layout";
import ScrollFix from "./utils/ScrollFix";
import AppRoutes from "./routes/AppRoutes";
import Loader from "./components/loader";
// Import the FAQ Widget (Make sure the path matches where you saved the file)
import FAQWidget from "./components/FAQWidget"; 
import { CurrencyProvider } from "./context/CurrencyContext";

const AppContent = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  useEffect(() => {
  const savedCurrency = localStorage.getItem("currency");

  if (!savedCurrency) {
    fetch("https://ipapi.co/json/")
      .then(res => res.json())
      .then(data => {
        const country = data.country_code;

        const currencyMap = {
          IN: "INR",
          US: "USD",
          GB: "GBP",
          EU: "EUR"
        };

        const currency = currencyMap[country] || "USD";
        localStorage.setItem("currency", currency);
      })
      .catch(() => {
        localStorage.setItem("currency", "USD");
      });
  }
}, []);

  useEffect(() => {
    // On every route change, show loader
    setLoading(true);

    const timer = setTimeout(() => {
      setLoading(false);
    }, 700); // 7s loader

    return () => clearTimeout(timer);
  }, [location]);

  // Show ONLY the loader while loading
  if (loading) {
    return <Loader />;
  }

  // Show full app only when not loading
  return (
    <>
      <ScrollFix />
      <Toaster position="top-right" autoClose={2000} />
      
      {/* The Layout wraps your pages */}
      <Layout>
        <AppRoutes />
      </Layout>

      {/* The Floating FAQ Widget sits outside layout but inside the fragment */}
      <FAQWidget />
    </>
  );
};

const App = () => {
  return (
    <Router>
      <AuthProvider>
        <CurrencyProvider>
          <AppContent />
        </CurrencyProvider>
      </AuthProvider>
    </Router>
  );
};

export default App;